import { render, staticRenderFns } from "./CustomerDet.vue?vue&type=template&id=3bed7040&"
import script from "./CustomerDet.vue?vue&type=script&lang=js&"
export * from "./CustomerDet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CustomerDet.vue"
export default component.exports